export default function CountryCodeInput({ value, onChange, disabled = false }) {
  return <div className="block text-xs text-slate-600">Country calling code (for mobile numbers)
    <input aria-label="Country calling code" type="tel" value={value} disabled={disabled} onChange={e => onChange(e.target.value)} placeholder="+91" maxLength={4} className="mt-1 block w-28 rounded border border-slate-300 p-2 text-sm" />
  </div>;
}
